import React from 'react';
import styled from 'styled-components';
import { Col, Row } from 'tdesign-react';
import DescriptionItem from '@/components/DescriptionItem';

export default function PartitionBasicInfo({ detail = {}, white }) {
  return (
    <Root gutter={[0, 10]} white={white}>
      <Col span={6}>
        <DescriptionItem label='订阅名' value={detail.subscription} />
      </Col>
      <Col span={6}>
        <DescriptionItem label='Topic' value={detail.topic} />
      </Col>
      <Col span={6}>
        <DescriptionItem label='分区' value={detail.partition} />
      </Col>
    </Root>
  );
}

const Root = styled(Row)`
  .description-label {
    width: auto;
    margin-right: 10px;
    font-size: 14px;
    ${(props) => props.white && `color: #fff`}
  }

  .description-value {
    font-size: 14px;
    ${(props) => props.white && `color: #fff`}
  }
`;
